// Secure storage utility with optional encryption
// For production, consider using additional security measures

const STORAGE_TYPE = process.env.REACT_APP_STORAGE_TYPE || 'localStorage';

export const secureStorage = {
  setItem: (key: string, value: string) => {
    if (STORAGE_TYPE === 'sessionStorage') {
      sessionStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, value);
    }
  },

  getItem: (key: string): string | null => {
    if (STORAGE_TYPE === 'sessionStorage') {
      return sessionStorage.getItem(key);
    } else {
      return localStorage.getItem(key);
    }
  },

  removeItem: (key: string) => {
    if (STORAGE_TYPE === 'sessionStorage') {
      sessionStorage.removeItem(key);
    } else {
      localStorage.removeItem(key);
    }
  },

  clear: () => {
    if (STORAGE_TYPE === 'sessionStorage') {
      sessionStorage.clear();
    } else {
      localStorage.clear();
    }
  }
};

// Additional security recommendations:
// 1. Use httpOnly cookies for tokens (requires backend changes)
// 2. Implement CSRF protection
// 3. Use secure headers (Content-Security-Policy, X-Frame-Options, etc.)
// 4. Consider using Web Crypto API for client-side encryption
// 5. Implement token rotation on sensitive operations